import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import { dataCatalog } from '../../../../../api/coreData'
import OperationalTable from '../../../../organisms/OperationalTable'
import { useConfigColumns } from '../../../../../hooks/useConfigColumns'
import ViewEventLogDetailsDialog from '../dialogs/ViewEventLogDetailsDialog'
import EventLogDetailsCell, { EventLogDetailsDialogContext } from './EventLogDetailsCell'

const columnsConfig = {
  columns: [
    { id: 'eventDate', accessor: 'eventDate', Header: 'Event Date', format: 'timestamp' },
    { id: 'eventType', accessor: 'eventType', Header: 'Event Type' },
    { id: 'message', accessor: 'message', Header: 'Message' },
    { id: 'severity', accessor: 'severity', Header: 'Level' },
    { id: 'who', accessor: 'actorName', Header: 'Who' },
    { id: 'details', accessor: 'detailId', Header: 'Details', Cell: EventLogDetailsCell }
  ],
  defaultSort: [{
    id: 'eventDate', desc: true
  }]
}

function RecentLogs ({ targetType, targetIdentifier }) {
  const dialogRef = useRef(null)

  const query = useMemo(() => {
    return {
      filters: {
        targetType,
        targetIdentifier
      },
      includes: { actorName: true },
      skip: 0,
      take: 100
    }
  }, [targetType, targetIdentifier])
  const { data, isLoading } = dataCatalog.useGetCatalogEventLogs(query)
  const _columns = useConfigColumns({
    columnsConfig
  })

  return (
    <EventLogDetailsDialogContext.Provider value={dialogRef}>
      <OperationalTable
        variant='v2'
        data={data?.logs ?? []}
        isLoading={isLoading}
        itemName='Logs'
        columns={_columns.columns}
        defaultSort={_columns.defaultSort}
        hideFooter
      />
      <ViewEventLogDetailsDialog ref={dialogRef} />
    </EventLogDetailsDialogContext.Provider>
  )
}

RecentLogs.propTypes = {
  targetType: PropTypes.string,
  targetIdentifier: PropTypes.string
}

export default RecentLogs
